import { useShow } from '@refinedev/core';
import { Show } from '@refinedev/antd';
import { theme } from 'antd';
import type { EmotionDetailOut } from '@/api/generated/schemas';
import { bareShowContentProps } from '@/components/common/show/shared';
import { useShowTab } from '@/components/common/show/useShowTab';
import { BulkModStatusControl } from '@/components/user_catalog/BulkModStatusControl';
import { useRecordDocumentTitle } from '@/hooks/useRecordDocumentTitle';
import { EMOTION_DEFAULT_TAB, EMOTION_SHOW_TABS } from '../constants';
import { EmotionShowHeader } from './EmotionShowHeader';
import { EmotionGeneralTab } from './EmotionGeneralTab';
import { EmotionCollectionTab } from './EmotionCollectionTab';
import { SearchPopularityCard } from '@/components/common/show/SearchPopularityCard';
import { CollectionPublicationsTable } from '@/components/user_catalog/collections/CollectionPublicationsTable';

export const EmotionShow = () => {
  const { token } = theme.useToken();
  const { query } = useShow<EmotionDetailOut>({
    resource: 'user_catalog.emotions',
  });
  const { data, isLoading } = query;
  const record = data?.data;

  useRecordDocumentTitle('user_catalog.emotions', record?.name);

  const [activeTab, onTabChange] = useShowTab(
    EMOTION_SHOW_TABS,
    EMOTION_DEFAULT_TAB
  );

  return (
    <Show
      isLoading={isLoading}
      contentProps={bareShowContentProps}
      headerButtons={({ defaultButtons }) => (
        <>
          {record?.id != null && (
            <BulkModStatusControl
              resource="user_catalog.emotions"
              ids={[record.id]}
              labelOf={() => record.name}
              onSuccess={() => query.refetch()}
            />
          )}
          {defaultButtons}
        </>
      )}
    >
      {record && (
        <>
          <EmotionShowHeader
            record={record}
            activeTab={activeTab}
            onTabChange={onTabChange}
          />
          <div style={{ marginTop: token.margin }}>
            {activeTab === 'general' && <EmotionGeneralTab record={record} />}
            {activeTab === 'publications' && (
              <CollectionPublicationsTable
                collectionId={record.id}
                collectionKind={record.collection_kind}
              />
            )}
            {activeTab === 'collection' && (
              <EmotionCollectionTab record={record} />
            )}
            {activeTab === 'search' && (
              <SearchPopularityCard value={record.search_popularity} />
            )}
          </div>
        </>
      )}
    </Show>
  );
};
